import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultCrtOverviewPageTwoData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'crt-overview-page-two-list',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'crt-overview-page-two-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Is a CRT right for me?',
                variant: 'h3',
              },
            },
            {
              id: 'crt-overview-page-two-estate',
              type: 'PresentationListItem',
              props: {
                title: 'Estate size',
                description:
                  'If your estate exceeds or is close to the federal estate tax exemption, a CRT can provide significant tax benefits.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'crt-overview-page-two-philanthropy',
              type: 'PresentationListItem',
              props: {
                title: 'Philanthropic intent',
                description:
                  'If you are committed to leaving a lasting charitable legacy, a CRT can be an efficient way to support the causes that you care about.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'crt-overview-page-two-income',
              type: 'PresentationListItem',
              props: {
                title: 'Income stability',
                description:
                  'A CRT provides a reliable source of income which can help with financial planning. A CRAT offers more income stability than a CRUT.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'crt-overview-page-two-appreciated-assets',
              type: 'PresentationListItem',
              props: {
                title: 'Appreciated assets',
                description:
                  'If you have assets that have already experienced significant appreciation, a CRT can help reduce and defer capital gains tax.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'crt-overview-page-two-guidance',
              type: 'PresentationListItem',
              props: {
                title: 'Professional guidance',
                description:
                  'Consulting with estate planning professionals, including attorneys and financial advisors, is essential to evaluate whether a CRT aligns with your overall financial strategy.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
    ],
  };
}
